import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaGlobe, FaUsers, FaMedal, FaGraduationCap, FaHeart, FaStar } from 'react-icons/fa';
import './About.css';
import { Helmet } from 'react-helmet';

const MissionVision = () => {
  const goals = [
    {
      icon: <FaGlobe />,
      title: 'Global Recognition',
      description: 'Develop players who represent India on international platforms and bring glory to the nation.'
    },
    {
      icon: <FaUsers />,
      title: 'Community Building',
      description: 'Create a vibrant badminton community that promotes health, sportsmanship, and lifelong friendships.'
    },
    {
      icon: <FaMedal />,
      title: 'Competitive Excellence',
      description: 'Produce consistent winners in state, national, and international badminton tournaments.'
    },
    {
      icon: <FaGraduationCap />,
      title: 'Holistic Development',
      description: 'Foster all-round development combining athletic excellence with academic and personal growth.'
    },
    {
      icon: <FaHeart />,
      title: 'Passion for Sport',
      description: 'Instill a deep love for badminton that lasts a lifetime, whether as a player or enthusiast.'
    },
    {
      icon: <FaStar />,
      title: 'Setting Standards',
      description: 'Establish benchmarks in coaching methodology and facility management for other academies.'
    },
  ];

  return (
    <>
      <Helmet>
        <title>Mission Vision</title>
      </Helmet>
      <div className="mission-vision-page">
        <div className="page-header">
          <div className="container">
            <h1>Mission & Vision</h1>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <Link to="/about">About</Link>
              <span>/</span>
              <span>Mission & Vision</span>
            </div>
          </div>
        </div>

        <section className="mv-section section">
          <div className="container">
            <div className="mission-vision-grid">
              <div className="mv-card">
                <div className="mv-icon">🎯</div>
                <h3>Our Mission</h3>
                <p>
                  At Imperial Badminton Academy, our mission is to provide high-quality, structured, and professional badminton training that empowers players to reach their highest potential. We are committed to developing technically strong, physically fit, and mentally confident athletes through systematic coaching and continuous performance evaluation.
                </p>
                <p>
                  Our mission focuses on nurturing talent at every level—beginners, intermediate players, and competitive athletes—by offering a positive and disciplined training environment. We strive to instill strong sports values such as dedication, integrity, teamwork, and respect, ensuring that our players grow not only as athletes but also as responsible individuals.
                </p>
                <p>
                  Through experienced coaching, modern infrastructure, and a player-centric approach, Imperial Badminton Academy aims to create a strong foundation for long-term success in badminton while promoting a healthy and active lifestyle.
                </p>
                <ul>
                  <li>
                    <FaCheckCircle />
                    <span>Deliver excellence in badminton coaching through innovative training methods</span>
                  </li>
                  <li>
                    <FaCheckCircle />
                    <span>Create an inclusive environment where every student can thrive</span>
                  </li>
                  <li>
                    <FaCheckCircle />
                    <span>Promote physical fitness and mental well-being through sport</span>
                  </li>
                  <li>
                    <FaCheckCircle />
                    <span>Build character, discipline, and sportsmanship in every player</span>
                  </li>
                </ul>
              </div>

              <div className="mv-card">
                <div className="mv-icon">🔭</div>
                <h3>Our Vision</h3>
                <p>
                  Our vision is to become a leading badminton academy recognized for excellence in training, talent development, and competitive success at district, state, national, and international levels. We aspire to be a center of excellence that sets new standards in badminton coaching through innovation, discipline, and professionalism.
                </p>
                <p>
                  Imperial Badminton Academy envisions creating future champions who compete with confidence, resilience, and sportsmanship. We aim to identify young talent early, guide them through structured development pathways, and prepare them for high-level competitions.
                </p>
                <p>
                  By continuously evolving our coaching methods and embracing modern sports science, we seek to inspire a new generation of badminton players and contribute meaningfully to the growth of badminton at the grassroots and professional levels.
                </p>
                <ul>
                  <li>
                    <FaCheckCircle />
                    <span>Become the top choice for aspiring badminton players across India</span>
                  </li>
                  <li>
                    <FaCheckCircle />
                    <span>Produce Olympic-caliber athletes who represent the nation with pride</span>
                  </li>
                  <li>
                    <FaCheckCircle />
                    <span>Set new standards in sports academy management and coaching</span>
                  </li>
                  <li>
                    <FaCheckCircle />
                    <span>Inspire the next generation to pursue excellence in badminton</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="goals-section section bg-light">
          <div className="container">
            <div className="section-title">
              <h2>Strategic Goals</h2>
              <p>
                Clear objectives that guide our path towards becoming India's most successful badminton academy.
              </p>
            </div>
            <div className="goals-grid">
              {goals.map((goal, index) => (
                <div key={index} className="goal-card">
                  <div className="goal-icon">{goal.icon}</div>
                  <h3>{goal.title}</h3>
                  <p>{goal.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="about-cta section bg-light">
          <div className="container">
            <div className="cta-box">
              <h2>Share Our Vision?</h2>
              <p>
                Join us in our mission to develop world-class badminton players. Whether you're
                a beginner or an aspiring professional, there's a place for you at Imperial.
              </p>
              <div className="cta-buttons">
                <Link to="/contact" className="btn btn-accent">
                  Join Our Academy <FaArrowRight />
                </Link>
                <Link to="/about/why-choose-us" className="btn btn-secondary">
                  Why Choose Us
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default MissionVision;
